<div class="rate py-10 position-relative d-flex flex-column">
  <button type="button"
          class="rate-close position-absolute btn-close"
          (click)="closeModal()"
  >
  </button>
  <div class="row justify-content-center flex-grow-1">
    <div class="col-11 col-md-9">
      <p class="rate__title text-center fw-bold text-primblack mb-2">
        How would you rate<br>
        your experience?
      </p>
      <p class="rate__text text-center fw-bold mb-8">
        Let us know how we are doing.
      </p>
      <div class="stars d-flex align-items-center justify-content-between mb-7">
        <div
          class="star d-flex"
          *ngFor="let star of rateStars; let i = index; trackBy: trackByFn"
          (click)="setRate(i + 1)"
        >
          <img
            *ngIf="star.rated"
            class="star_fill"
            src="/assets/icons/star_fill.svg"
            alt="">
          <img
            *ngIf="!star.rated"
            class="star_clear"
            src="/assets/icons/star_clear.svg"
            alt="">
        </div>
      </div>
      <button
        type="button"
        class="btn btn-outline app-btn-black w-100"
        [class.disabled]="rate === 0"
        (click)="sendRate()"
      >
        Rate
      </button>
    </div>
  </div>
</div>
